import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { StyledDialog } from "../../styled/dialog";
import CircularLoading from "../loadingData/circularLoading";
import CustomDialog from "./customDialog";

const ConfirmDeleteDialog = ({
  open,
  handleClose,
  handleConfirm,
  title,
  text,
  loading,
}) => {
  return (
    <CustomDialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {
          loading ? <CircularLoading /> : <p>{text}</p>
        }
      </DialogContent>
      <StyledDialog.Actions>
        <Button onClick={handleClose} disabled={loading} color="primary">

          Cancelar
        </Button>
        <Button
          disabled={loading}
          onClick={handleConfirm}
          sx={{ backgroundColor: "red", color: "white" }}
          variant="contained">
          Eliminar
        </Button>
      </StyledDialog.Actions>
    </CustomDialog>
  );
};

export default ConfirmDeleteDialog;
